export const Location = () => {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 7.54545C15 12.6364 8 17 8 17C8 17 1 12.6364 1 7.54545C1 5.80949 1.7375 4.14463 3.05025 2.91712C4.36301 1.68961 6.14348 1 8 1C9.85652 1 11.637 1.68961 12.9497 2.91712C14.2625 4.14463 15 5.80949 15 7.54545Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
